/**
 * O texto do filtro por campo (#568), o mesmo que a API lê em `?campos=`:
 * condições separadas por `;`, cada uma `<id do campo>:<valor>`. Lista de
 * opções: os ids das opções separados por vírgula. Sim/não: `sim` ou `nao`.
 * Data: `AAAA-MM-DD..AAAA-MM-DD`, um lado pode faltar.
 */

import type { CampoPersonalizado } from '@cliqcrm/contracts';

export interface CondicaoNaTela {
  readonly campoId: string;
  readonly valor: string;
}

/** Os tipos que filtram hoje. Texto, número e valor em R$ ainda não. */
export function filtravel(campo: CampoPersonalizado): boolean {
  return (
    !campo.arquivado &&
    (campo.tipo === 'lista_unica' ||
      campo.tipo === 'lista_multipla' ||
      campo.tipo === 'sim_nao' ||
      campo.tipo === 'data')
  );
}

export function lerFiltro(texto: string): CondicaoNaTela[] {
  return texto
    .split(';')
    .map((parte) => parte.trim())
    .filter((parte) => parte.includes(':'))
    .map((parte) => {
      const separador = parte.indexOf(':');
      return { campoId: parte.slice(0, separador), valor: parte.slice(separador + 1) };
    });
}

export function escreverFiltro(condicoes: readonly CondicaoNaTela[]): string {
  return condicoes.map((condicao) => `${condicao.campoId}:${condicao.valor}`).join(';');
}

/** Um filtro por campo: escolher de novo o mesmo campo troca o valor. */
export function comCondicao(texto: string, condicao: CondicaoNaTela): string {
  return escreverFiltro([
    ...lerFiltro(texto).filter((atual) => atual.campoId !== condicao.campoId),
    condicao,
  ]);
}

export function semCondicao(texto: string, campoId: string): string {
  return escreverFiltro(lerFiltro(texto).filter((atual) => atual.campoId !== campoId));
}

function emData(texto: string): string {
  const [ano, mes, dia] = texto.split('-');
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : texto;
}

/** "Como conheceu: Instagram", para a pílula do filtro ativo. */
export function rotuloDaCondicao(campo: CampoPersonalizado | undefined, valor: string): string {
  if (!campo) return 'Campo que não existe mais';
  if (campo.tipo === 'sim_nao') return `${campo.nome}: ${valor === 'sim' ? 'Sim' : 'Não'}`;
  if (campo.tipo === 'data') {
    const [de = '', ate = ''] = valor.split('..');
    if (de && ate) return `${campo.nome}: de ${emData(de)} a ${emData(ate)}`;
    return de ? `${campo.nome}: a partir de ${emData(de)}` : `${campo.nome}: até ${emData(ate)}`;
  }
  const nomes = valor
    .split(',')
    .map((id) => campo.opcoes.find((opcao) => opcao.id === id)?.nome)
    .filter((nome): nome is string => nome !== undefined);
  return `${campo.nome}: ${nomes.join(' ou ')}`;
}
